import React from 'react'
import Board from './Board'


const Game = () => {
  return (
    <>
       <Board/>
    </>
  )
}

export default Game